var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src && !_vm.failedToLoad)?_c('v-lazy-image',{staticClass:"icon icon_filled",class:{
      icon_loading: !_vm.isLoaded
  },style:({
    width: _vm.size,
    height: _vm.size
  }),attrs:{"src":_vm.src,"width":_vm.size,"height":_vm.size,"intersection-options":{rootMargin: '500px'}},on:{"error":function($event){_vm.failedToLoad = true},"load":function($event){_vm.isLoaded = true}}}):_c('div',{staticClass:"icon",style:({
    width: _vm.size,
    height: _vm.size
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }